/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// $('.Modal__Close').click(function(){
//   	$(this).parents('.Modal').find('video').trigger('pause');
// });


window.addEventListener('DOMContentLoaded', (event) => {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains("QuickView__Action")) {
        var item = event.target;
        var id = item.getAttribute("data-variant-id");
        var wrapper = item.parentElement;
        var parrent = wrapper.parentElement;
        
        if (id && item.classList.contains('available')) {
          if (parrent.classList.contains('disabled')) return false;
          
          let formData = {
            'items': [
              {
                'id': id,
                'quantity': 1
              }
            ]
          };
      
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then((resp) => { 
            return resp.json();
          })
          .then((data) => {
            parrent.classList.add('disabled');

            setTimeout(() => {
              parrent.classList.remove('disabled');
            }, 3000)
            
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));

            var toggleButton = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
            toggleButton.click();
          })
          .catch((err) => {
            console.error('Error: ' + err);
          }) 
        }
      };
    });
});
